/** Read profile id from the current URL `t` param only. */
export function getUrlProfileId(): string | null {
  if (typeof window === "undefined") return null;
  const param = new URLSearchParams(window.location.search).get("t");
  const trimmed = param?.trim() ?? "";
  return trimmed.length > 0 ? trimmed : null;
}
